import React, { useState } from 'react';

import { isNotEmpty } from '../../src/utils/utils';
import { useSavedSearch } from './SavedSearchContext';

function withSeavedSearchWrapper<TProps>(
  Component: React.ComponentType<TProps>
) {
  return function SeavedSearchWrapper(
    props: Omit<
      TProps,
      'fieldsValid' | 'isFieldTouched' | 'putSavedSearches' | 'handleBlur'
    >
  ) {
    const [fieldsValid, setFieldsValid] = useState({});
    const [isFieldTouched, setIsFieldTouched] = useState({});
    const { updateSearch } = useSavedSearch();

    const putSavedSearches = async (id: number, alertFrequency: string) => {
      updateSearch(id, { alertFrequency });
    };

    const validateName = (value: string | undefined) => {
      let valid = isNotEmpty(value);
      return valid;
    };

    const handleBlur = (
      id: number,
      e: React.ChangeEvent<HTMLInputElement>,
      name: string | null
    ) => {
      const value = e.target.value;
      let valid = validateName(value);
      setFieldsValid({ ...fieldsValid, [id]: valid });
      setIsFieldTouched({ ...isFieldTouched, [id]: true });
      if (!value || value === name) return;
      updateSearch(id, { name: value });
    };

    return (
      <Component
        {...(props as TProps)}
        fieldsValid={fieldsValid}
        isFieldTouched={isFieldTouched}
        putSavedSearches={putSavedSearches}
        handleBlur={handleBlur}
      />
    );
  };
}

export default withSeavedSearchWrapper;
